import { useEffect, useRef, useState } from "react";
import { IMG } from "../data/content";

const VIDEOS = [
  "https://videos.pexels.com/video-files/31617700/13470979_1920_1080_24fps.mp4",
  "https://videos.pexels.com/video-files/29466024/12684277_1920_1080_60fps.mp4",
  "https://videos.pexels.com/video-files/7578552/7578552-hd_1920_1080_30fps.mp4",
  "https://videos.pexels.com/video-files/7578554/7578554-hd_1920_1080_30fps.mp4",
  "https://videos.pexels.com/video-files/7578545/7578545-hd_1920_1080_30fps.mp4",
  "https://videos.pexels.com/video-files/7578540/7578540-hd_1920_1080_30fps.mp4",
  "https://videos.pexels.com/video-files/7578549/7578549-hd_1920_1080_30fps.mp4",
  "https://videos.pexels.com/video-files/35904584/15230181_1920_1080_24fps.mp4",
];

// Max seconds to show each clip before advancing (keeps rotation lively)
const MAX_CLIP_SECONDS = 9;

export default function HeroVideo() {
  const [active, setActive] = useState(0);
  const refs = useRef([]);
  const timerRef = useRef(null);

  const advance = () => setActive((i) => (i + 1) % VIDEOS.length);

  useEffect(() => {
    const vid = refs.current[active];
    if (vid) {
      try {
        vid.currentTime = 0;
        const p = vid.play();
        if (p && p.catch) p.catch(() => {});
      } catch (e) { /* autoplay guard */ }
    }
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(advance, MAX_CLIP_SECONDS * 1000);
    return () => clearTimeout(timerRef.current);
  }, [active]);

  return (
    <div className="absolute inset-0 overflow-hidden" data-testid="hero-video">
      {VIDEOS.map((src, i) => (
        <video
          key={src}
          ref={(el) => (refs.current[i] = el)}
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-[1200ms] ease-in-out"
          style={{ opacity: i === active ? 1 : 0 }}
          muted
          playsInline
          preload="auto"
          poster={IMG.hero}
          onEnded={advance}
        >
          <source src={src} type="video/mp4" />
        </video>
      ))}

      {/* progress dots */}
      <div className="absolute bottom-8 right-8 z-10 flex gap-2">
        {VIDEOS.map((_, i) => (
          <button
            key={i}
            data-testid={`hero-video-dot-${i}`}
            aria-label={`Show clip ${i + 1}`}
            onClick={() => setActive(i)}
            className={`h-1.5 rounded-full transition-all duration-500 ${
              i === active ? "w-8 bg-accent" : "w-3 bg-white/40 hover:bg-white/70"
            }`}
          />
        ))}
      </div>
    </div>
  );
}
